import ImageButton from './ImageButton';
import DefaultImage from '../../assets/UILookAndFeel/Default/close.png';

function CloseButton({ onClick, className, style }: { onClick: () => void; className?: string; style?: any }) {
  return (
    <ImageButton title="ปิด" className={className} onClick={onClick} defaultImage={''} style={style}>
      <img src={DefaultImage} alt="" />
    </ImageButton>
  );
}

export default CloseButton;
